import { GET_ALL_PAGES_USER } from "@api/queriesV2/cms";
import { getPages } from "./getPages";

export const getSsrCmsPagesProps = ({ locale, type, slug }) => {
  return getPages({
    getPageProps: {
      query: GET_ALL_PAGES_USER,
      context: { clientName: "v2" },
      fetchPolicy: "network-only",
      variables: {
        language: locale,
        type,
        ...(slug ? { slug } : {}),
      },
    },
  });
};
